import { NetworkStatus } from '@apollo/client';
import { QueryRef, useQueryRefHandlers, useReadQuery } from '@apollo/client';
import { EmptyState } from '@synoptic/ui-kit/empty-state/empty-state.js';
import { SearchIcon } from '@synoptic/ui-kit/icons/react/search.js';
import { startTransition } from 'react';
import { SearchStreamPostsQueryQuery } from '@/__generated__/graphql';
import { PostFeed } from '@/components/post-feed/post-feed';
import { useStreamPostsLoaderData } from './loader';
import { useStreamFeedProps } from './use-stream-feed-props.tsx';

export const StreamPostsSearchFeed = ({
  queryRef,
  skeletonItemCount,
}: {
  queryRef: QueryRef<SearchStreamPostsQueryQuery>;
  skeletonItemCount?: number;
}) => {
  const { fetchMore } = useQueryRefHandlers(queryRef);
  const { q } = useStreamPostsLoaderData();
  const feedProps = useStreamFeedProps();

  const {
    data: {
      searchStreamPosts: { items },
    },
    networkStatus,
  } = useReadQuery(queryRef);

  const onEndReached = () => {
    startTransition(() => {
      fetchMore({
        variables: { offset: items.length },
      });
    });
  };

  if (items.length === 0) {
    return (
      <EmptyState
        illustration={<SearchIcon />}
        heading={q ? `No results found for "${q}”` : 'No results found'}
        description={'Try adjusting the filters or time range.'}
      />
    );
  }

  return (
    <PostFeed
      style={{ opacity: networkStatus === NetworkStatus.loading ? 0.5 : '' }}
      data={items}
      endReached={onEndReached}
      initialItemCount={skeletonItemCount}
      {...feedProps}
      gap={0}
    />
  );
};
